import { Outlet } from "react-router-dom";

/** Root public layout; each marketing page renders its own header and footer */
const Layout = () => <Outlet />;

export default Layout;
